<template>
  <b-modal ref="modal"
    title="Redditi componente nucleo familiare"
    size="lg"
    class="large"
    centered no-close-on-backdrop>

    <div class="box">

      <div class="col-12 box-header">Dati generali</div>
      <div class="row box-body">

        <div role="group" class="col-12 col-md-3 stack-label">
          <label>Nome</label>
          <b-input v-model.trim="reddito.nome" type="text" :formatter="formatUcase" size="sm" :state="fieldState('nome')"/>
          <b-form-invalid-feedback v-if="!$v.reddito.nome.required">Campo obbligatorio</b-form-invalid-feedback>
        </div>

        <div role="group" class="col-12 col-md-3 stack-label">
          <label>Cognome</label>
          <b-input v-model.trim="reddito.cognome" type="text" :formatter="formatUcase" trim size="sm" :state="fieldState('cognome')"/>
          <b-form-invalid-feedback v-if="!$v.reddito.cognome.required">Campo obbligatorio</b-form-invalid-feedback>
        </div>

        <div role="group" class="col-12 col-md-3 stack-label">
          <label>Data di nascita</label>
          <b-input v-model="reddito.dataNascita" type="date" size="sm" :state="fieldState('dataNascita')"/>
          <b-form-invalid-feedback v-if="!$v.reddito.dataNascita.required">Campo obbligatorio</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.reddito.dataNascita.verificaNascita">Verificare anno di nascita.</b-form-invalid-feedback>
        </div>

        <div role="group" class="col-12 col-md-3 stack-label">
          <label>Codice Fiscale</label>
          <b-input v-model="reddito.codiceFiscale" type="text" :formatter="formatUcase" size="sm" :state="fieldState('codiceFiscale')"/>
          <b-form-invalid-feedback v-if="!$v.reddito.codiceFiscale.required">Campo obbligatorio</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.reddito.codiceFiscale.codiceFiscaleExtended">Codice fiscale non corretto</b-form-invalid-feedback>
        </div>

        <div role="group" class="col-12 col-md-3 stack-label">
          <label for="inputLive">% disabilità</label>
          <b-input v-model="reddito.percDisabilita" type="number" size="sm" :state="fieldState('percDisabilita')"
          @change="updatePercDisabilita"/>

          <b-form-invalid-feedback v-if="!$v.reddito.percDisabilita.between">Il valore deve essere tra 0 e 100</b-form-invalid-feedback>

        </div>

        <div role="group" class="col-12 col-md-3 stack-label">
          <label for="inputLive">Data fine disabilità</label>
          <b-input v-model="dataFineHandicap" type="date" size="sm" :state="fieldState('dataFineValiditaHandicap')"
          @update="updateDataHandicap" />
          <b-form-invalid-feedback v-if="!$v.reddito.dataFineValiditaHandicap.dataHandicap">Data disabilità non valida!</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.reddito.dataFineValiditaHandicap.greaterThanEqual">Deve essere maggiore o uguale alla di 'Data di nascita'</b-form-invalid-feedback>
        </div>

        <div role="group" class="col-12 col-md-3 stack-label">
          <label>Parentela</label>
          <b-form-select v-model="reddito.tipoComponente" :options="tipoComponenteOptions" size="sm" :state="fieldState('tipoComponente')"/>
          <b-form-invalid-feedback v-if="!$v.reddito.tipoComponente.required">Campo obbligatorio</b-form-invalid-feedback>
        </div>

        <div role="group" class="col-12 col-md-3 stack-label">
          <label>Data decesso</label>
          <b-input v-model="reddito.dataDecesso" type="date" size="sm" :state="fieldState('dataDecesso')"/>
          <b-form-invalid-feedback v-if="!$v.reddito.dataDecesso.greaterThanEqual">Deve essere maggiore  di 'Data di nascita'</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.reddito.dataDecesso.verificaDataDecesso">Deve essere maggiore o uguale alla data odierna</b-form-invalid-feedback>
        </div>

        <div role="group" class="col-12 col-mb-2 d-flex mt-3" >
          <b-form-checkbox v-model="reddito.nonResidente">
            Non residente
          </b-form-checkbox>
        </div>

        <div role="group" class="col-12 col-md-6 stack-label">
          <label>{{ reddito.nonResidente ? 'Appartenente al nucleo dal' : 'Residente dal' }}</label>
          <b-input v-model="reddito.residenteDal" type="date" size="sm" :state="fieldState('residenteDal')"/>
          <b-form-invalid-feedback>Campo obbligatorio</b-form-invalid-feedback>
        </div>

        <div role="group" class="col-12 col-md-6 stack-label">
          <label>{{ reddito.nonResidente ? 'Appartenente al nucleo al' : 'Residente al' }}</label>
          <b-input v-model="residenteAl" type="date" size="sm" :state="fieldState('residenteAl')" @input="updateResidenteAl"/>
          <b-form-invalid-feedback v-if="!$v.reddito.residenteAl.greaterThan">Deve essere maggiore di 'Residente dal'</b-form-invalid-feedback>
        </div>

        
        <div v-if="reddito.tipoComponente === 'IS'" class="col-12 mt-3">
          <div class="p-3 bg-warning rounded text-center">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1 text-left font-weight-bold">
                <label>Attivare la pratica di subentro?</label>
                <b-form-group :state="fieldState('richiestaPraticaSubentro')" class="mb-0">
                  <b-form-radio-group
                    v-model="reddito.richiestaPraticaSubentro"
                    :options="[
                      { text: 'Sì', value: 'SI' },
                      { text: 'No', value: 'NO' }
                    ]"
                    :state="fieldState('richiestaPraticaSubentro')"
                  ></b-form-radio-group>
                  <b-form-invalid-feedback v-if="!$v.reddito.richiestaPraticaSubentro.required">
                    Indicare se avviare la pratica di subentro
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
        

      </div>
    </div>

    <div v-if="!reddito.modelli.length" class="box my-2">
      <div class="box-body text-center font-italic p-3">
        Nessun reddito dichiarato
      </div>
    </div>

    <template v-else>
      <div class="scrollable">
        <ModelloForm v-for="(m,idx) in reddito.modelli" :key="idx" :modello="m"
        @input="onModelloInput(idx)" @remove="removeModello(idx)" />
      </div>
    </template>

    <div class="box">

      <div class="col-12 box-header">Totale redditi (€)</div>

      <div class="row box-body">
        <div role="group" class="col-12 col-md-3 stack-label">
          <label>pensione</label>
          <b-input class="text-right" v-model="reddito.redditiPensione" type="number" size="sm" :disabled="true"/>
        </div>

        <div role="group" class="col-12 col-md-3 stack-label">
          <label>lavoro dipendente</label>
          <b-input class="text-right" v-model="reddito.redditiDipendente" type="number" size="sm" :disabled="true"/>
        </div>

        <div role="group" class="col-12 col-md-3 stack-label">
          <label>lavoro autonomo</label>
          <b-input class="text-right" v-model="reddito.redditiAutonomo" type="number" size="sm" :disabled="true"/>
        </div>

        <div role="group" class="col-12 col-md-3 stack-label">
          <label>altri redditi</label>
          <b-input class="text-right" v-model="reddito.redditiAltri" type="number" size="sm" :disabled="true"/>
        </div>

      </div>
    </div>

    <template slot="modal-footer">

      <!-- {{reddito.allegatoHandicap}}
      {{reddito.allegatoHandicap.file ? reddito.allegatoHandicap.file.size : 0}} -->
      <template v-if="reddito.percDisabilita > 0">
        <input :id="`${reddito.allegatoHandicap.idAllegato}`" :ref="`${reddito.allegatoHandicap.idAllegato}`" type="file" :value="reddito.allegatoHandicap.fileSelected"
          accept="image/jpeg,image/png,application/pdf" style="display: none;" @change="setFile" />

        <b-button v-if="!reddito.allegatoHandicap.fileName" variant="info" @click="selectFile(reddito.allegatoHandicap)" :disabled="!reddito.codiceFiscale">
          <font-awesome-icon icon="file-alt"/>Allega
        </b-button>

        <b-button v-if="reddito.allegatoHandicap.fileName && item.stato !== 'V'" variant="info" @click="clearFiles">
          <font-awesome-icon icon="file-alt"/>Rimuovi allegato
        </b-button>
      </template>

      <b-button v-if="idx===-1" variant="success" @click="add">
        <font-awesome-icon icon="plus"/>Aggiungi
      </b-button>

      <b-button v-else variant="success" @click="update">
        <font-awesome-icon icon="edit"/>Aggiorna
      </b-button>

      <b-dropdown variant="primary" class="mx-md-2">
        <template slot="button-content">
          <font-awesome-icon icon="plus" class="mr-2"/>Aggiungi dichi.
        </template>
        <b-dropdown-item @click="addModello('3')">Modello 730</b-dropdown-item>
        <b-dropdown-item @click="addModello('U')">Modello Unico</b-dropdown-item>
        <b-dropdown-item @click="addModello('S')">Modello CU</b-dropdown-item>
      </b-dropdown>

      <b-button 
        v-if="idx!==-1" 
        variant="danger" 
        @click="remove"
        :disabled="!canRemoveComponente"
        v-b-tooltip.hover
        :title="!canRemoveComponente ? 'Non è possibile rimuovere i componenti del nucleo familiare originale' : ''"
      >
        <font-awesome-icon icon="trash-alt" class="mr-2"/>Rimuovi comp.
      </b-button>

      <b-button variant="outline-secondary" @click="close">
        <font-awesome-icon icon="times" class="mr-2"/>Annulla
      </b-button>
    </template>
  </b-modal>
</template>

<script>
// import moment from 'moment'
import { required, between } from 'vuelidate/lib/validators'
import cloneDeep from 'lodash/cloneDeep'
import CodiceFiscale from '../utils/codice-fiscale'
import ModelloForm from '@/components/ModelloForm'
import numeral from 'numeral'
import 'numeral/locales'

// const formatData = (value, vm) => {
//   let retValue = value ? moment(value, 'YYYY/MM/DD').format('DD/MM/YYYY') : ''

//   return retValue
// }

const codiceFiscaleExtended = (value, vm) => {
  let idRet = true
  if (!value || value.length !== 16) return false
  try {
    // Verifica del carattere di controllo originale
    const cfBase = value.slice(0, 15)
    const checkCode = CodiceFiscale.getCheckCode(cfBase)
    if (checkCode !== value[15].toUpperCase()) {
      return false
    }
    
    // Denormalizziamo il value prima di fare i confronti
    const denormalizedValue = CodiceFiscale.denormalizeOmocodie(value)
    let cf1 = CodiceFiscale.computeInverse(denormalizedValue)

    if (vm.dataNascita && idRet) {
      let dn = vm.dataNascita.split('-')
      cf1.name = vm.nome
      cf1.surname = vm.cognome
      cf1.day = parseInt(dn[2])
      cf1.month = parseInt(dn[1])
      cf1.year = parseInt(dn[0])

      // L'anno deve essere compreso tra l'anno corrente ed il 1900
      // console.log('Verifica anno', cf1.year, cf1.year < 1900, cf1.year > new Date().getFullYear())
      if (cf1.year < 1900 || cf1.year > new Date().getFullYear()) {
        idRet = false
      } else {
        let cf2 = CodiceFiscale.compute(cf1)
        // console.log('cf2 after compute', cf2)
        //Non controlliamo il comune di nascita e l'ultimo carattere del codice fiscale
        idRet = cf2.substring(0, 11) === denormalizedValue.toUpperCase().substring(0, 11)
        // console.log('idRet', idRet)
        // console.log('cf2.substring(0, 11)', cf2.substring(0, 11))

      }
      return idRet
    }
    return true
  } catch (err) {
    return false
  }
}

const verificaNascita = (value, vm) => {
  let idRet = true
  if (!value) idRet = true
  try {
    if (value && idRet) {
      let dn = value.split('-')
      let year = parseInt(dn[0])
      // L'anno deve essere compreso tra l'anno corrente ed il 1900
      // console.log('Verifica anno', year, year < 1900, year > new Date().getFullYear())
      if (year < 1900 || year > new Date().getFullYear()) idRet = false
    }
    return idRet
  } catch (err) {
    return false
  }
}

const verificaDataSTD = (value, vm) => {
  let idRet = true
  if (!value) idRet = true
  try {
    if (value && idRet) {
      let dn = value.split('-')
      let year = parseInt(dn[0])
      // L'anno deve essere compreso tra l'anno corrente ed il 1900
      // console.log('Verifica anno', year, year < 1900, year > new Date().getFullYear())
      if (year < 1900 || (year > new Date().getFullYear() && year !== 9999)) idRet = false
    }
    return idRet
  } catch (err) {
    return false
  }
}

const greaterThan = (field) => (value, vm) => {
  if (!value) return true
  return value > vm[field]
}

const greaterThanEqual = (field) => (value, vm) => {
  if (!value) return true
  return value >= vm[field]
}

const dataHandicap = (field) => (value, vm) => {
  let idRet = false
  let idCheck = false

  if (vm[field] > 0) idCheck = true // C'è scritto qualcosa su field

  // console.log('Controllo idCheck', idCheck)
  // console.log('Controllo value', value)
  // console.log('Controllo vm[dataAnnoImposta]', vm['dataAnnoImposta'])
  // console.log('Controllo vm[field]', field, vm[field], !idCheck && !value)

  // if (idCheck && !!value) idRet = true
  if (idCheck && value > vm['dataAnnoImposta']) idRet = true
  if (!idCheck && !value) idRet = true

  return idRet
}

const verificaDataDecesso = (value, vm) => {
  if (!value) return true
  const oggi = new Date().toISOString().split('T')[0]
  return value <= oggi
}

export default {
  name: 'RedditoModal',

  components: {
    ModelloForm
  },

  data () {
    return {
      item: {},
      reddito: this.emptyReddito(),
      idx: -1,
      validationMessage: '',
      dataFineHandicap: '',
      residenteAl: ''
    }
  },

  validations: {
    reddito: {
      nome: { required },
      cognome: { required },
      dataNascita: { required, verificaNascita },
      codiceFiscale: { required, codiceFiscaleExtended },
      tipoComponente: { required },
      percDisabilita: { between: between(0, 100) },
      dataFineValiditaHandicap: { greaterThanEqual: greaterThanEqual('dataNascita'), dataHandicap: dataHandicap('percDisabilita') },
      residenteDal: { required, greaterThanEqual: greaterThanEqual('dataNascita') },
      residenteAl: { verificaDataSTD, greaterThan: greaterThan('residenteDal') },
      dataDecesso: { 
        verificaDataSTD, 
        greaterThanEqual: greaterThanEqual('dataNascita'),
        verificaDataDecesso 
      },
      richiestaPraticaSubentro: {
        required(value) {
          if (this.reddito.tipoComponente === 'IS') {
            return value !== null && value !== undefined && value !== '';
          }
          return true;
        }
      }
    }
  },

  computed: {
    tipoComponenteOptions () {
      const options = this.$store.state.options.tipoComponente;
      
      // Mostra IS e ZZ solo se è sessione CAF E c'è un dichiarante diverso dall'intestatario
      const hasDichiarante = this.item && this.item.cfDichiarante && this.item.cfDichiarante !== this.item.codiceFiscale;
      const isCafWithDichiarante = this.$store.state.auth.user && 
                                  this.$store.state.auth.user.isCafSession && 
                                  hasDichiarante;
      
      if (!isCafWithDichiarante) {
        return options.filter(opt => 
          opt.value !== 'IS' && opt.value !== 'ZZ'
        );
      }
      
      // Se è una sessione CAF con dichiarante, restituisco tutte le opzioni
      return options;
    },
    canRemoveComponente() {
      // console.log("RedditoModal - Verifica rimozione", {
      //   cf: this.reddito.codiceFiscale,
      //   isOriginal: this.reddito.isOriginal,
      //   redditoCompleto: this.reddito
      // });
      return !this.reddito.isOriginal;
    }
  },

  methods: {

    emptyReddito () {
      return {
        nome: '',
        cognome: '',
        dataNascita: '',
        codiceFiscale: '',
        tipoComponente: '',
        percDisabilita: 0,
        dataFineValiditaHandicap: '',
        nonResidente: false,
        residenteDal: '',
        residenteAl: '',
        dataDecesso: '',
        modelli: [],
        origineSoggetto: 'NU',
        dataAnnoImposta: '',
        allegatoHandicap: { idAllegato: 'h', fileName: null, file: null },
        richiestaPraticaSubentro: null
      }
    },

    fieldState (field) {
      let v = this.$v.reddito[field]
      return v.$dirty && v.$error ? false : null
    },

    updatePercDisabilita () {
      if (this.reddito.percDisabilita === '0' || !this.percDisabilita) {
        this.dataFineHandicap = ''
        this.reddito.dataFineValiditaHandicap = this.dataFineHandicap
        this.reddito.allegatoHandicap.file = null
        this.reddito.allegatoHandicap.fileName = null
      }

      // console.log('updatePercDisabilita this.percDisabilita', this.reddito.percDisabilita)
      // console.log('updatePercDisabilita this.dataFineHandicap', this.dataFineHandicap)
      // return this.dataFineHandicap === '9999-12-31' ? '' : this.dataFineHandicap
    },
    updateDataHandicap () {
      this.reddito.dataFineValiditaHandicap = this.dataFineHandicap
      if (this.dataFineHandicap === '9999-12-31') this.dataFineHandicap = ''
      // console.log('updateDataHandicap', this.dataFineHandicap)
    },
    formatDataHandicap (value) {
      let idRet = value
      if (value === '9999-12-31') idRet = ''
      // console.log('formatDataHandicap', idRet, value)
      return idRet
    },
    updateResidenteAl () {
      this.reddito.residenteAl = this.residenteAl
      if (this.residenteAl === '9999-12-31') this.residenteAl = ''
    },

    async open ({ item, idx }) {
      this.$v.$reset()
      this.validationMessage = ''
      this.item = item
      this.idx = idx >= 0 ? idx : -1
      // console.log('TEST LODASH cloneDeep', cloneDeep(item.redditi[idx]))
      let reddito = idx >= 0 ? cloneDeep(item.redditi[idx]) : this.emptyReddito()
      reddito.dataAnnoImposta = this.item.anno + '-01-01'
      if (!reddito.allegatoHandicap) reddito.allegatoHandicap = { idAllegato: 'h', fileName: null, file: null }
      if (!reddito.percDisabilita || reddito.percDisabilita === '0') reddito.dataFineValiditaHandicap = ''
      this.dataFineHandicap = reddito.dataFineValiditaHandicap === '9999-12-31' ? '' : reddito.dataFineValiditaHandicap
      // console.log('this.dataFineHandicap', this.dataFineHandicap)
      // console.log('reddito.dataFineValiditaHandicap', reddito.dataFineValiditaHandicap)
      // this.residenteAl = reddito.residenteAl
      this.residenteAl = reddito.residenteAl === '9999-12-31' ? '' : reddito.residenteAl
      if (!reddito.modelli) reddito.modelli = []
      this.reddito = reddito
      await this.$store.dispatch('options/loadTipoComponenteOptions')
      this.$refs.modal.show()
    },

    close () {
      this.$refs.modal.hide()
    },

    async addModello (tipoModello) {
      if (this.reddito.modelli.length) {
        let m = this.reddito.modelli[0]
        if (tipoModello !== 'S' || tipoModello !== m.tipMod) {
          this.$ui.notify({
            type: 'warning',
            title: 'Attenzione',
            message: 'Il modello di dichiarazione selezionato non può essere aggiunto a quello esistente. Rimuovere prima il modello esistente.'
          })
          return
        }
      }

      let rs = await this.$store.dispatch('modelli/loadModello', { tipoModello, annoImposta: this.item.anno })
      this.reddito.modelli = this.reddito.modelli || []
      this.reddito.modelli.push(rs)
    },

    removeModello (idx) {
      this.reddito.modelli.splice(idx, 1)
      this.calcolaTotali()
    },

    onModelloInput (idx) {
      this.calcolaTotali()
    },

    calcolaTotali () {
      let reddito = this.reddito
      let modelli = reddito.modelli
      let totali = { ALTRO: 0, NN: 0, LAVDIP: 0, LAVAUT: 0, PENSI: 0 }
      if (modelli && modelli.length) {
        modelli.forEach(d => {
          d.quadri.forEach(q => {
            q.celle.forEach(c => {
              if (c.importo) totali[c.tipRedPat] += parseFloat(c.importo)
            })
          })
        })
      }
      this.$set(this.reddito, 'redditiPensione', totali.PENSI)
      this.$set(this.reddito, 'redditiDipendente', totali.LAVDIP)
      this.$set(this.reddito, 'redditiAutonomo', totali.LAVAUT)
      this.$set(this.reddito, 'redditiAltri', totali.ALTRO)
    },

    validate () {
      this.$v.$touch()
      // console.log('VALIDATE this.$v.$invalid', this.$v.$invalid, this.$v)
      return !this.$v.$invalid
    },

    add () {
      let validationMessage = ''
      if (!this.validate()) {
        if (!this.$v.reddito.dataFineValiditaHandicap.dataHandicap) {
          this.reddito.dataFineValiditaHandicap = '9999-12-31'
          // validationMessage = 'Data fine validità impostata a ' + formatData(this.reddito.dataFineValiditaHandicap)
          validationMessage = 'Data fine validità non impostata, aggiornare di nuovo per conferma!'
        } else {
          this.$ui.notify({
            type: 'warning',
            title: 'Attenzione',
            message: `I dati inseriti non sono corretti! ${validationMessage ? '(' + validationMessage + ')' : ''}`
          })
        }
        this.validationMessage = ''
      } else {
        // console.log('prima della push', this.item.redditi)
        if (!this.reddito.residenteAl) this.reddito.residenteAl = '9999-12-31'
        if (!this.item.redditi) this.$set(this.item, 'redditi', [this.reddito])
        else this.item.redditi.push(this.reddito)
        // console.log('dopo la push', this.item.redditi)

        this.close()
      }
    },

    update () {
      let validationMessage = 'I dati inseriti non sono corretti! '
      if (!this.validate()) {
        if (!this.$v.reddito.dataFineValiditaHandicap.dataHandicap) {
          this.reddito.dataFineValiditaHandicap = '9999-12-31'
          // validationMessage = 'Data fine validità impostata a ' + formatData(this.reddito.dataFineValiditaHandicap)
          validationMessage = 'Data fine validità non impostata, aggiornare di nuovo per conferma!'
        }
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          // message: `I dati inseriti non sono corretti! ${validationMessage ? '(' + validationMessage + ')' : ''}`
          message: validationMessage
        })
        this.validationMessage = ''
      } else {
        if (!this.reddito.residenteAl) this.reddito.residenteAl = '9999-12-31'
        this.$set(this.item.redditi, this.idx, this.reddito)
        this.close()
      }
    },

    remove() {
      if (!this.canRemoveComponente) {
        console.log("RedditoModal - Rimozione bloccata: componente originale");
        this.$ui.notify({
          type: 'warning',
          title: 'Operazione non consentita',
          message: 'Non è possibile rimuovere i componenti del nucleo familiare originale'
        });
        return;
      }

      console.log("RedditoModal - Procedo con rimozione");
      this.item.redditi.splice(this.idx, 1);
      this.close();
    },

    formatUcase (value, event) {
      return value.toUpperCase()
    },

    formatValuta (value, event) {
      numeral.locale('it')
      // console.log('value.toLocaleString()',value.toLocaleString('it-IT'), numeral(value).format())
      // return value.toLocaleString('it-IT')
      return numeral(value).format()

      // return value
    },

    selectFile (refValue) {
      // console.log('selectFile', refValue.idAllegato)
      // console.log('this.$refs[refValue.idAllegato]', this.$refs[refValue.idAllegato])

      this.$refs[refValue.idAllegato].click()
      // console.log('refValue.fileSelected', refValue.fileSelected)
    },
    setFile (upl) {
      // console.log('setFile upl', upl)
      const file = upl.target.files.length ? upl.target.files[0] : ''
      // console.log('setFile', upl.target.id, this.reddito.allegatoHandicap, file)
      this.$emit(upl.target.id, upl.target.files.length ? upl.target.files[0] : '')
      // Object.assign(this.reddito.allegatoHandicap, { file: file })
      this.reddito.allegatoHandicap.file = file

      // let idx = this.item.allegati.findIndex(x => x.idAllegato === upl.target.id)
      // console.log('Array', file.name)

      this.reddito.allegatoHandicap.fileName = file.name
      this.reddito.allegatoHandicap.fileType = file.type

      // console.log('this.reddito.allegatoHandicap', this.reddito.allegatoHandicap)
    },

    clearFiles () {
      // refValue.file = null
      // refValue.fileName = null

      this.reddito.allegatoHandicap.fileName = null
      this.reddito.allegatoHandicap.file = null

      // console.log('this.reddito.allegatoHandicap', this.reddito.allegatoHandicap)
    }

  },

  watch: {
    'reddito.tipoComponente': function(newValue, oldValue) {
      if (oldValue === 'IS' && newValue !== 'IS') {
        this.reddito.richiestaPraticaSubentro = null;
      }
    }
  }
}

</script>

<style lang="stylus" scoped>
.scrollable {
  max-height: max(20rem, 50vh);
  overflow-y: scroll;
}

.large >>> .modal-lg {
  min-width: 60rem !important;
}
</style>
